// Import the app config.
import AppConfig from '@config/app';
// Import enumerations.
import {
	AppEnvironment
} from '@app/enumerations';
// Import the abstraction class for controller factory.
import AbstractControllerFactory from './AbstractControllerFactory';
// Import the production controller factory.
import ProductionControllerFactory from './ProductionControllerFactory';
// Impor the mock controller factory.
import MockControllerFactory from './MockControllerFactory';

export default class ControllerFactoryProvider {

	public static getControllerFactory = (): AbstractControllerFactory => {
		switch (AppConfig.mode) {
			case AppEnvironment.MOCK:
				return new MockControllerFactory();
			default:
				return new ProductionControllerFactory();
		}
	}
}